var _rect, _rect2, _rect3, _path, _path2, _mask, _g, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElementCard45(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 299,
    fill: "none",
    viewBox: "0 0 247 299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 292,
    x: 7,
    y: 7,
    fill: "#234CFB",
    fillOpacity: 0.2,
    rx: 13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 292,
    fill: "#fff",
    rx: 13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 291,
    x: 0.5,
    y: 0.5,
    stroke: "#234CFB",
    strokeOpacity: 0.8,
    rx: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95B2EE",
    fillRule: "evenodd",
    d: "M222.5 21c1.381 0 2.5-1.12 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.12-2.5 2.5 1.119 2.5 2.5 2.5zM213.5 21c1.381 0 2.5-1.12 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.12-2.5 2.5 1.119 2.5 2.5 2.5zM204.5 21c1.381 0 2.5-1.12 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.12-2.5 2.5 1.119 2.5 2.5 2.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#234CFB",
    fillOpacity: 0.1,
    fillRule: "evenodd",
    d: "M13 49h215v190H13V49z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "2p9qfl2eda",
    width: 215,
    height: 190,
    x: 13,
    y: 49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13 49h215v190H13V49z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2p9qfl2eda)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M149.301 22.407l19.398 1.659-15.279 123.417 84.414-14.548 4.332 25.13-59.857 10.315 24.695 110.712-20.008 4.463-24.913-111.689L9.166 198.222l-4.332-25.129 55.429-9.554L23.63 43.351l20.74-6.102 37.364 122.59 51.655-8.903 15.912-128.529z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#234CFB",
    strokeOpacity: 0.5,
    d: "M149.738 22.946l18.401 1.574-15.215 122.902-.083.668.664-.114 83.922-14.463 4.161 24.144-59.363 10.23-.518.09.114.512 24.586 110.224-19.032 4.245-24.804-111.201-.103-.464-.469.08L9.573 197.645l-4.16-24.144 54.934-9.469.559-.096-.165-.543L24.256 43.689l19.78-5.82 37.22 122.116.129.422.434-.075 51.655-8.903.366-.063.046-.368 15.852-128.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF003C",
    fillRule: "evenodd",
    d: "M121 129c2.209 0 4 1.677 4 3.746 0 1.544-1.184 3.889-3.553 7.036-.035.047-.079.089-.129.122-.237.159-.56.115-.742-.093l-.023-.029-.098-.131c-2.303-3.081-3.455-5.383-3.455-6.905 0-2.069 1.791-3.746 4-3.746zm0 2.2c-.947 0-1.714.739-1.714 1.65 0 .911.767 1.65 1.714 1.65s1.714-.739 1.714-1.65c0-.911-.767-1.65-1.714-1.65z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    x: 127,
    y: 63,
    fill: "#fff",
    stroke: "#FF003C",
    strokeWidth: 2,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#234CFB",
    d: "M180.216 81.712c.159 0 .288.129.288.288v34.272c0 .159-.129.288-.288.288h-15.411l.001-19.861c0-.286-.209-.524-.483-.569l-.093-.007h-10.848c-.286 0-.524.209-.568.483l-.008.093-.001 19.861h-15.213c-.159 0-.288-.129-.288-.288V82c0-.16.129-.288.288-.288h42.624z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 6,
    x: 140.309,
    y: 96.023,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 6,
    x: 168.309,
    y: 96.023,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M138.328 75.88h41.397c.321 0 .6.221.673.534l2.986 12.83c-.461 2.994-1.901 4.492-4.32 4.492-2.419 0-4.205-1.152-5.357-3.456-1.249 2.304-2.881 3.456-4.897 3.456-2.016 0-3.662-1.152-4.936-3.456-1.163 2.304-2.807 3.456-4.933 3.456s-3.77-1.152-4.933-3.456c-1.094 2.304-2.649 3.456-4.665 3.456s-3.572-1.152-4.666-3.456c-.784 2.304-2.57 3.456-5.357 3.456-2.705 0-4.141-1.41-4.308-4.233l-.012-.26 2.651-12.812c.066-.32.349-.551.677-.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF003C",
    fillRule: "evenodd",
    d: "M146.512 75.88l-1.7 14.673c-.046-.09-.091-.18-.135-.273-.784 2.304-2.57 3.456-5.357 3.456-2.749 0-4.188-1.458-4.315-4.374l-.005-.119 2.651-12.812c.066-.32.349-.551.677-.551h8.184zM163.558 75.88l.378 14.51-.062-.11c-1.163 2.304-2.807 3.456-4.933 3.456s-3.77-1.152-4.933-3.456l-.036.076.474-14.476h9.112zM179.725 75.88c.321 0 .6.221.673.534l2.986 12.83c-.461 2.994-1.901 4.492-4.32 4.492-2.419 0-4.205-1.152-5.357-3.456l-.099.18-1.692-14.58h7.809z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.134,
    fillRule: "evenodd",
    d: "M135 89.243h48.384l-.021.131c-.482 2.908-1.915 4.362-4.299 4.362-2.419 0-4.205-1.152-5.357-3.456-1.249 2.304-2.881 3.456-4.897 3.456-2.016 0-3.662-1.152-4.936-3.456-1.163 2.304-2.807 3.456-4.933 3.456s-3.77-1.152-4.933-3.456c-1.094 2.304-2.649 3.456-4.665 3.456s-3.572-1.152-4.666-3.456c-.784 2.304-2.57 3.456-5.357 3.456-2.749 0-4.188-1.458-4.315-4.374l-.005-.119z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF003C",
    fillRule: "evenodd",
    d: "M139.32 73h39.456c.954 0 1.728.774 1.728 1.728v.576c0 .636-.516 1.152-1.152 1.152h-40.608c-.636 0-1.152-.516-1.152-1.152v-.576c0-.954.774-1.728 1.728-1.728z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#234CFB",
    fillOpacity: 0.5,
    d: "M136.44 118.216h44.928c.159 0 .288-.129.288-.288v-2.88c0-.159-.129-.288-.288-.288H136.44c-.159 0-.288.129-.288.288v2.88c0 .159.129.288.288.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#234CFB",
    fillOpacity: 0.1,
    d: "M148.44 120.017h20.928c.159 0 .288-.129.288-.288v-2.88c0-.16-.129-.288-.288-.288H148.44c-.159 0-.288.128-.288.288v2.88c0 .159.129.288.288.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#234CFB",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M210.465 151.164l-14.169 2.538-.555-3.097 14.168-2.538.556 3.097zm-42.506 7.614l14.169-2.538-.556-3.097-14.169 2.538.556 3.097zm-14.169 2.537l-14.168 2.538-.556-3.096 14.169-2.538.555 3.096zm-42.506 7.614l14.169-2.538-.556-3.096-14.168 2.538.555 3.096zm-14.168 2.538l-14.169 2.538-.555-3.097 14.168-2.538.556 3.097zm-42.506 7.614l14.169-2.538-.556-3.097-14.169 2.538.556 3.097zm-28.337 5.075l14.168-2.538-.555-3.096-14.169 2.538.556 3.096z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF003C",
    fillRule: "evenodd",
    d: "M30 254c2.21 0 4 1.677 4 3.746 0 1.544-1.184 3.889-3.553 7.036-.035.047-.08.089-.13.122-.236.159-.56.115-.74-.093l-.024-.029-.098-.131C27.152 261.57 26 259.268 26 257.746c0-2.069 1.79-3.746 4-3.746zm0 2.2c-.947 0-1.714.739-1.714 1.65 0 .911.767 1.65 1.714 1.65s1.714-.739 1.714-1.65c0-.911-.767-1.65-1.714-1.65z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#234CFB",
    fillOpacity: 0.5,
    d: "M151.069 257c.994 0 1.8.806 1.8 1.8 0 .944-.728 1.719-1.653 1.794l-.147.006H46.8c-.994 0-1.8-.806-1.8-1.8 0-.944.727-1.719 1.652-1.794L46.8 257h104.269zM111.069 269c.994 0 1.8.806 1.8 1.8 0 .944-.728 1.719-1.653 1.794l-.147.006H46.8c-.994 0-1.8-.806-1.8-1.8 0-.944.727-1.719 1.652-1.794L46.8 269h64.269z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7C3FF",
    d: "M74.594 15c1.933 0 3.5 1.567 3.5 3.5 0 1.869-1.465 3.395-3.308 3.495l-.192.005H29.5c-1.933 0-3.5-1.567-3.5-3.5 0-1.869 1.464-3.395 3.308-3.495L29.5 15h45.094z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#234CFB",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    d: "M1 37.5h239"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementCard45);
export default __webpack_public_path__ + "static/media/ElementCard45.fab9a45f.svg";
export { ForwardRef as ReactComponent };